import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:px-4" }
const _hoisted_2 = {
  key: 0,
  class: "text-xs text-center"
}
const _hoisted_3 = {
  key: 1,
  class: "text-[10px] font-bold text-center"
}

export function render(_ctx, _cache) {
  const _component_PopupMainNavbar = _resolveComponent("PopupMainNavbar")
  const _component_PopupAffiliateNavbar = _resolveComponent("PopupAffiliateNavbar")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PopupMainNavbar),
    _createVNode(_component_PopupAffiliateNavbar),
    _createElementVNode("div", _hoisted_1, [
      _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "text-xl text-amber-100 text-start font-extrabold my-3" }, "รายงานแนะนำเพื่อน", -1 /* HOISTED */)),
      _createVNode(_component_Card, { pt: {root:'bg-[#34513bd4]! border-4! border-[#34513b]!', body: 'px-2!'} }, {
        content: _withCtx(() => [
          _createVNode(_component_DataTable, {
            value: _ctx.reports.records,
            loading: _ctx.tableLoading,
            scrollable: "",
            scrollHeight: "400px",
            tableStyle: "min-width: 30rem;",
            size: "small",
            class: "table-auto",
            pt: {tableContainer: 'min-h-[250px]', thead: 'bg-[#5e8367d4]!', tbody: ''}
          }, {
            header: _withCtx(() => [
              _createElementVNode("form", {
                class: "flex items-center gap-2 w-full",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["prevent"]))
              }, [
                _createVNode(_component_DatePicker, {
                  modelValue: _ctx.form.dates,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.form.dates) = $event)),
                  selectionMode: "range",
                  manualInput: false,
                  class: "w-full",
                  "input-class": "w-full text-sm!",
                  pt: { panel: 'z-[9999]!' }
                }, null, 8 /* PROPS */, ["modelValue"]),
                _createVNode(_component_Button, {
                  label: "ค้นหา",
                  type: "submit",
                  size: "small",
                  class: "w-24",
                  onClick: _ctx.handleSearch,
                  loading: _ctx.form.btn.loading
                }, null, 8 /* PROPS */, ["onClick", "loading"])
              ], 32 /* NEED_HYDRATION */)
            ]),
            empty: _withCtx(() => [
              (_ctx.tableLoading)
                ? (_openBlock(), _createElementBlock("p", _hoisted_2, "กำลังโหลดข้อมูล"))
                : (_openBlock(), _createElementBlock("p", _hoisted_3, "ไม่พบข้อมูล"))
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "parent",
                header: "แม่ข่าย",
                "header-class": "text-xs text-end",
                "body-class": "text-xs",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }),
              _createVNode(_component_Column, {
                field: "child",
                header: "ลูกข่าย",
                "header-class": "text-xs text-end",
                "body-class": "text-xs",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }),
              _createVNode(_component_Column, {
                field: "type",
                header: "ประเภท",
                "header-class": "text-xs text-end",
                "body-class": "text-xs",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }),
              _createVNode(_component_Column, {
                field: "value",
                header: "จำนวน",
                "header-class": "text-xs text-end",
                "body-class": "text-xs",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              }, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(slotProps.data.value)), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_Column, {
                field: "createdDate",
                header: "วันที่",
                sortable: "",
                "header-class": "text-xs text-end",
                "body-class": "text-xs",
                pt: {headerCell:'bg-transparent! text-amber-50!'}
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["value", "loading"]),
          _createVNode(_component_Paginator, {
            first: _ctx.first,
            "onUpdate:first": _cache[2] || (_cache[2] = $event => ((_ctx.first) = $event)),
            rows: _ctx.rows,
            totalRecords: _ctx.totalRecords,
            template: "FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink",
            currentPageReportTemplate: "{first} ถึง {last} ทั้งหมด {totalRecords}",
            pt: { root: 'bg-[#24402bd4]! border-2! border-[#14361c]! px-0! mt-5!', current: 'text-xs!' }
          }, null, 8 /* PROPS */, ["first", "rows", "totalRecords"])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 64 /* STABLE_FRAGMENT */))
}